import { Injectable } from '@angular/core';
import { AbstractCRUDService, AlarisApiService } from '@campaign-portal/components-library';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { SenderFields } from '@campaign-portal/namespace/entities/sender-id/specs';
import { exist, Id } from '@campaign-portal/namespace/common/id';
import { CustomForm } from '@campaign-portal/namespace/entities/custom-forms/specs';

@Injectable()
export class SendersCustomFieldsService implements AbstractCRUDService {
	entity = '';
	title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);

	customFormsList: CustomForm<exist>[] = [];
	requestCustomFormIds: Id<exist>[] = [];

	update = this.create;
	delete = this.create;

	constructor(private readonly api: AlarisApiService) {}

	read(): Observable<ReadResponse<SenderFields[]>> {
		return this.api.loader<ReadResponse<SenderFields[]>>('SenderFields.Read', {}, this.loading$).pipe(
			tap((resp) => {
				const { customFormsFields, requestCustomFormIds } = resp.Data.at(0) ?? {};
				this.customFormsList = customFormsFields ?? [];
				this.requestCustomFormIds = requestCustomFormIds ?? [];
			})
		);
	}

	create(): Observable<void> {
		return of(undefined);
	}
}
